import { ParamsWithoutTime, ScheduledAction } from '@hh.ru/magritte-common-func-utils/types';

export const requestAnimation: ScheduledAction = (func) => {
    let frame: ReturnType<typeof requestAnimationFrame> | null = null;
    let that: unknown;
    let _args: ParamsWithoutTime<typeof func> | null = null;

    const scheduled = function (this: unknown, ...args: ParamsWithoutTime<typeof func>) {
        if (frame !== null) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            that = this;
            _args = args;
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        that = this;
        _args = args;

        frame = requestAnimationFrame((time) => {
            frame = null;
            if (_args !== null) {
                func.apply(that, [time, ..._args]);
            }
        });
    };

    scheduled.cancel = () => {
        if (frame !== null) {
            cancelAnimationFrame(frame);
            frame = null;
            _args = null;
        }
    };

    return scheduled;
};
